import React from 'react';
import styled from '@emotion/styled';
import { IAirline } from '@move-frontend/dap';
import { Column, IColumnProps } from './Column';
import Responsive from '../../../../../../ui/utils/Responsive';

const StyledColumn = styled(Column)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		background-color: #f7f7f7;
	}
`;

const StyledAirlineWrap = styled.div`
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	img {
		max-width: 100px;
		height: auto;
	}
`;

const StyledCodeShareFlightNumber = styled.span`
	display: none;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: block;
	}
`;

interface IProps extends IColumnProps {
	airline?: IAirline;
	icaoOperatingAirline: string;
	codeShareFlightNumber: string;
}

export const AirlineColumn = ({
	airline,
	icaoOperatingAirline,
	codeShareFlightNumber,
	columns,
}: IProps) => (
	<StyledColumn columns={columns}>
		<StyledAirlineWrap>
			{airline && airline.logo ? (
				<img src={airline.logo} alt={airline.name} />
			) : airline && airline.name ? (
				<span>{airline.name}</span>
			) : (
				<span>{icaoOperatingAirline}</span>
			)}

			<StyledCodeShareFlightNumber>
				{codeShareFlightNumber}
			</StyledCodeShareFlightNumber>
		</StyledAirlineWrap>
	</StyledColumn>
);
